import React, { useState } from 'react';

// The connected phone's IDs during a USB capture. First the GMA test-device
// ID for RequestConfiguration.setTestDeviceIds: the SDK's own logged value
// when seen, else MD5(android_id) worked out at connect. Then the GAID, from
// rdid on a captured GAM request. Click a chip to copy the full value.

const short = (v) => (v.length > 14 ? `${v.slice(0, 8)}…${v.slice(-4)}` : v);

function Chip({ label, value, title }) {
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    try { await navigator.clipboard.writeText(value); setCopied(true); setTimeout(() => setCopied(false), 1200); } catch { /* clipboard blocked */ }
  };
  return (
    <button
      onClick={copy}
      title={`${title}\n${value}\nClick to copy`}
      style={{ fontSize: 11, fontFamily: 'monospace', padding: '2px 6px', borderRadius: 4, border: '1px solid var(--line)', background: 'var(--bg)', color: 'inherit', cursor: 'pointer', whiteSpace: 'nowrap' }}
    >
      {label} {copied ? 'copied' : short(value)}
    </button>
  );
}

export default function DeviceIdChips({ device, stats, waitingHint = false }) {
  const androidId = device && device.androidId;
  const logged = stats && stats.loggedTestId;
  const testId = logged || (device && device.testDeviceId);
  const gaid = stats && stats.gaid;
  if (!testId && !gaid && !waitingHint) return null;
  const testTitle = [
    'Test device ID for RequestConfiguration.Builder().setTestDeviceIds(...) (Android).',
    logged ? 'Read from the SDK\'s own log line on this phone.' : `MD5 of android_id ${androidId}, uppercased (the SDK logs the same value on a non-test device).`,
  ].join('\n');
  return (
    <span style={{ display: 'inline-flex', gap: 6, alignItems: 'center', flexWrap: 'wrap' }}>
      {testId && <Chip label="Test ID" value={testId} title={testTitle} />}
      {gaid && (
        <Chip label="GAID" value={gaid}
          title={`Advertising ID, from rdid on a captured GAM request${stats.lat ? ' (is_lat=1: limit ad tracking on)' : ''}. Not the setTestDeviceIds value on Android.`} />
      )}
      {!gaid && waitingHint && (
        <span style={{ fontSize: 11, color: 'var(--muted)' }} title="The GAID is read from rdid on a GAM request, so it shows once an ad loads.">
          GAID: waiting for a GAM request
        </span>
      )}
    </span>
  );
}
